<template>
  <v-container>
    <div v-if="isLoaded">
      <!-- Affichage du message si aucune donnée -->
      <card-alert
        v-if="isEmpty"
        :msg="errorEmpty.msg"
        :icon="errorEmpty.icon"
        :color="errorEmpty.color"
      />
      <!-- Affichage de la courbe -->
      <line-chartsjs-template
        v-else
        :datacollection="themeData"
        :options="lineOptions"
      />
    </div>
    <div v-else>
      <!-- Affichage du message d'erreur -->
      <card-alert
        v-if="hasError"
        :msg="errorMsg"
      />
      <!-- Affichage du chargement -->
      <v-row
        v-else
        justify="center"
      >
        <circle10 />
      </v-row>
    </div>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import LineChartsjsTemplate from './templates/LineChartsjsTemplate.vue'
  import CardAlert from '../alerts/CardAlert.vue'
  import { Circle10 } from 'vue-loading-spinner'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'ChartThemeU',

    /* Sous-composants utilisés par ce composant */
    components: {
      LineChartsjsTemplate,
      CardAlert,
      Circle10,
    },

    /* Paramètres */
    props: {
      title: {
        type: String,
        default: '',
      },
      subtitle: {
        type: String,
        default: '',
      },
      isLoaded: {
        type: Boolean,
        default: false,
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      themeData: Object,
      errorMsg: {
        type: String,
        default: '',
      },
      labels: {
        type: Object,
        default: function () {
          return {
            x: 'Mois',
            y: 'Note',
          }
        },
      },
      manualTicksLimit: {
        type: Boolean,
        default: true,
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      isEmpty: function () {
        if (this.themeData) {
          return this.themeData.labels.length === 0
        }
        return true
      },

      lineOptions: function () {
        return {
          spanGaps: true,
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: this.labels.x,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  maxTicksLimit: this.manualTicksLimit ? 10 : undefined,
                  padding: 25,
                  max: this.manualTicksLimit ? 10 : undefined,
                  min: 0,
                },
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: this.labels.y,
                },
              },
            ],
          },
          scaleBeginAtZero: true,
        }
      },
    },
  }
</script>
